@if (views) {
	<form class="container without-default-focus">
		<fa-icon [icon]="faFilter"></fa-icon>
		<label>Vues :</label>
		<div>
			<input #selectControl type="text" placeholder="" aria-label="Number" matInput [formControl]="selectFormControl" [matAutocomplete]="auto" />
			<mat-autocomplete
				#auto="matAutocomplete"
				[displayWith]="displayLabel"
				(opened)="opened()"
				(closed)="closed()"
				class="view-autocomplete"
				panelWidth="fit-content"
				(optionSelected)="selected($event)">
				@for (view of filteredViews | async; track view) {
					<mat-option [value]="view">
						{{ view.name }}
					</mat-option>
				}
			</mat-autocomplete>
			<fa-icon [icon]="faCaretDown" (click)="selectControl.focus()"></fa-icon>
		</div>
	</form>
}
